module.exports = __webpack_public_path__ + "media/images/click-a2f6c02940bc4a0ecc95f6dd55869003.svg";